import { Alert, Box, Stack, Typography } from "@mui/material";
import React from "react";
import { useGetAssemblyQuery } from "../api/playbookApi";
import { AssemblyType } from "../types/assembly-model";
import { useAssemblyContext } from "../context/AssemblyContext";

const getTypeString = (type?: AssemblyType) => {
  switch (type) {
    case AssemblyType.DocxPerDocument:
      return "Per Document";
    case AssemblyType.DocxFlowWide:
      return "Flow Wide";
    default:
      return "Assembly";
  }
};

const AssemblyDetails = () => {
  const ctx = useAssemblyContext();
  const { data: assembly, error } = useGetAssemblyQuery(ctx);

  return (
    <Box sx={{ borderBottom: "1px solid", borderColor: "divider", p: 2 }}>
      <Stack direction="row">
        <Stack direction="column" flex={1} alignItems="flex-start">
          <Typography color="textSecondary" fontSize={12}>
            Assembly • {getTypeString(assembly?.assemblyType)}
          </Typography>
          <Typography variant="body1" fontWeight={500}>
            {assembly?.name ?? "…"}
          </Typography>
        </Stack>
        <Stack direction="column" flex={1}>
          <Typography color="textSecondary" fontSize={12}>
            Source
          </Typography>
          <Typography variant="body1" fontWeight={500}>
            {ctx.source === "flow" ? "Flow" : "Playbook"}
          </Typography>
        </Stack>
      </Stack>
      {error && <Alert severity="error">Failed to load assembly information.</Alert>}
    </Box>
  );
};

export default AssemblyDetails;
